/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  setShowBrokerRemunerationSection,
}) {
  return questionnaire.map(question => {
    if (question.idQuestion === 171) {
      const showBrokerRemunerationSection = question?.idAnswerOption === 1166;
      setShowBrokerRemunerationSection(showBrokerRemunerationSection);
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
  setShowBrokerRemunerationSection,
  brokerRemunerationGroup,
  setBrokerRemunerationGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    let saveQuestionnaire = false;

    if (question.idQuestion === 171) {

      const showBrokerRemunerationSection = value?.idAnswerOption === 1166;
      setShowBrokerRemunerationSection(showBrokerRemunerationSection);

      let allQuestion = [];
      for (const group of brokerRemunerationGroup) {
        allQuestion = [...allQuestion, ...group]
          .map((question) => question.idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers);
      }

      setBrokerRemunerationGroup(
        brokerRemunerationGroup.map((group) => {
          group.map((question) => (question.behaviorObject.isRequired = showBrokerRemunerationSection));
          return group;
        })
      );

      if (!setShowBrokerRemunerationSection) {
        setQuestionnaireAnswersToDelete([...questionnaireAnswersToDelete, ...allQuestion]);
      } else {
        setQuestionnaireAnswersToDelete([
          ...questionnaireAnswersToDelete.filter((question) => !questionnaireAnswersToDelete.includes(question)),
        ]);
      }
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('BROKER_REMUNERATION_FEE_CLIENT - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("BROKER_REMUNERATION_FEE_CLIENT - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('BROKER_REMUNERATION_FEE_CLIENT - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };